import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

// Influencer "link-in-bio" storefront. Reuses the shared storefront product
// endpoints (create/update/archive/list are storefront_id-scoped) and adds
// influencer-specific setup + views/clicks analytics. Sales are NOT tracked.
export class InfluencerStorefrontService {

    // ---- Storefront setup (owner_type='influencer', brand_id NULL) ----
    static async setupStorefront(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/storefront/influencer/setup", data, null);
        } catch (error) { throw new Error(`setupStorefront: ${error}`); }
    }

    static async getMyStorefront(influencer_id: number, account_id: number): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/storefront/influencer/my?influencer_id=${influencer_id}&account_id=${account_id}`, null);
        } catch (error) { throw new Error(`getMyStorefront: ${error}`); }
    }

    static async checkSlug(slug: string, influencer_id: number, account_id: number): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/storefront/influencer/slug-check?slug=${slug}&influencer_id=${influencer_id}&account_id=${account_id}`, null);
        } catch (error) { throw new Error(`checkSlug: ${error}`); }
    }

    static async getAnalytics(params: { influencer_id: number; account_id: number; start_date?: string; end_date?: string }): Promise<any> {
        try {
            const query = new URLSearchParams(
                Object.fromEntries(
                    Object.entries(params)
                        .filter(([, v]) => v !== undefined && v !== '')
                        .map(([k, v]) => [k, String(v)])
                )
            ).toString();
            return await http.getRequest(BASE_URL + `/storefront/influencer/analytics?${query}`, null);
        } catch (error) { throw new Error(`getAnalytics: ${error}`); }
    }

    // ---- Products (shared endpoints, storefront_id-scoped) ----
    static async getMyProducts(params: { storefront_id: number; page?: number; limit?: number; category?: string; status?: string; search?: string }): Promise<any> {
        try {
            const query = new URLSearchParams(params as any).toString();
            return await http.getRequest(BASE_URL + `/storefront/products?${query}`, null);
        } catch (error) { throw new Error(`getMyProducts: ${error}`); }
    }

    static async createProduct(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/storefront/products", data, null);
        } catch (error) { throw new Error(`createProduct: ${error}`); }
    }

    static async updateProduct(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/storefront/products/update", data, null);
        } catch (error) { throw new Error(`updateProduct: ${error}`); }
    }

    static async archiveProduct(product_id: number): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/storefront/products/archive", { product_id }, null);
        } catch (error) { throw new Error(`archiveProduct: ${error}`); }
    }

    // ---- Public storefront (shared public endpoint) ----
    static async getPublicStorefront(slug: string): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/storefront/view/${slug}`, null);
        } catch (error) { throw new Error(`getPublicStorefront: ${error}`); }
    }

    // Impression beacon — fire-and-forget from the public storefront page.
    static async trackView(data: { slug: string; visitor_id: string; session_id: string; product_id?: number }): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/storefront/track-view", data, null);
        } catch (error) { /* never block the page on analytics */ return null; }
    }

    // Tracked outbound product link (logs a click, then 302s to the affiliate URL).
    static clickUrl(click_token: string): string {
        return `${BASE_URL}/storefront/r/${click_token}`;
    }
}
